import { PageDesignerContainerContext } from "../types"
import { useContext } from "react"

export function usePageDesigner() {
  const context = useContext(PageDesignerContainerContext)
  return context.designer
}
